/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Gift_No_MessageInputs */

const vi_order_gift_no_message = /** @type {(inputs: Order_Gift_No_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có`)
};

/**

* @param {Order_Gift_No_MessageInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_gift_no_message = /** @type {((inputs?: Order_Gift_No_MessageInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Gift_No_MessageInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_gift_no_message(inputs)
});